import { servicesRoutes } from '@/Services/services.routes';
const servicesModule = {
    routes: servicesRoutes
};
export default servicesModule;
